import { render, staticRenderFns } from "./BlockGridAdvantagesItem.vue?vue&type=template&id=579a9cb8&scoped=true&"
import script from "./BlockGridAdvantagesItem.vue?vue&type=script&lang=ts&"
export * from "./BlockGridAdvantagesItem.vue?vue&type=script&lang=ts&"
import style0 from "./BlockGridAdvantagesItem.vue?vue&type=style&index=0&id=579a9cb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579a9cb8",
  null
  
)

export default component.exports